import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import QRCode from "qrcode";
import { X } from "lucide-react";
import { getDeskCode } from "@/lib/api";

// For the front-desk tablet: this gym's check-in QR, full screen. Staff scan it in FPA to clock in;
// members scan it in the LIFTR app to check in (points and XP every visit). The code changes every
// 30 seconds, so only someone standing at the desk can scan it (a photo of it stops working).
// Keeps the screen awake where the browser allows it.
export default function WorkDeskQr() {
  const nav = useNavigate();
  const [desk, setDesk] = useState(null);
  const [png, setPng] = useState("");
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    let timer, lock;
    const load = async () => {
      try {
        const d = await getDeskCode();
        setDesk(d); setOffline(false);
        setPng(await QRCode.toDataURL(d.qr, { width: 900, margin: 2, errorCorrectionLevel: "M" }));
        timer = setTimeout(load, Math.max(2, d.refresh_in) * 1000 + 300);
      } catch {
        setOffline(true);
        timer = setTimeout(load, 5000);
      }
    };
    load();
    navigator.wakeLock?.request?.("screen").then((l) => { lock = l; }).catch(() => {});
    return () => { clearTimeout(timer); lock?.release?.(); };
  }, []);

  return (
    <div className="fixed inset-0 z-[70] bg-white text-zinc-900 flex flex-col items-center justify-center gap-6 p-6" data-testid="work-desk-qr"
      style={{ paddingTop: "max(env(safe-area-inset-top), 24px)", paddingBottom: "max(env(safe-area-inset-bottom), 24px)" }}>
      <button type="button" aria-label="Close" onClick={() => nav("/work")} className="absolute right-4 top-4 p-2 text-zinc-500">
        <X className="h-7 w-7" />
      </button>
      <div className="text-center">
        <div className="font-display text-3xl font-extrabold uppercase">Check in here</div>
        <div className="mt-1 text-lg text-zinc-600">{desk?.gym} · Members: LIFTR app → Check in · Staff: FPA → Clock in</div>
      </div>
      {png ? <img src={png} alt="Check-in QR code" className="w-[min(80vw,60vh)] h-[min(80vw,60vh)]" />
        : <div className="w-[min(80vw,60vh)] h-[min(80vw,60vh)] bg-zinc-100 rounded-xl" />}
      <div className={`text-sm ${offline ? "text-rose-600" : "text-zinc-500"}`}>
        {offline ? "No connection. Reconnecting…" : "Changes every 30 seconds"}
      </div>
    </div>
  );
}
